import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError,BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { Subject } from 'rxjs-compat';



@Injectable({
  providedIn: 'root'
})
export class ConversionService {

  private moduleName: string = "User";
  urlEnv = environment.endpoint;

  authState = new BehaviorSubject(localStorage.getItem('authToken') ? true : false);
  userid = new BehaviorSubject(0);
  
  constructor(
    private http: HttpClient,
    private router: Router,
  ) { }

  getHeaders() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('authToken')
      })
    };
  }
  
  handleError(error: HttpErrorResponse) {
    console.log(error);
    return throwError(error);
  }

  convertToPeso(amount, currency:string){
    let convRate = JSON.parse(localStorage.getItem('conversionRate'))
    let converted = amount;

    let currencyConvRate = convRate.find(ccr =>{
      return ccr.currency.toLowerCase() == currency.toLowerCase();
    })

    currencyConvRate ? converted *= currencyConvRate.rate : 0;

    return converted;
  }
  
  getConversion_Latest() {
    const url = this.urlEnv + '/api/conversionrate/latest/';
    console.log("conversion url", url);
    this.http.get(url).subscribe(res => {
      console.log("conversion rates", res);
      localStorage.setItem('conversionRate', JSON.stringify(res))
    });
  }

}
